var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var SORTED_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

var formatTime = function formatTime(time) {
  if (!time) return null;
  var splitTime = time.match(/.{1,2}/g);
  return splitTime ? splitTime.join(':') : null;
};

var formatTimeInterval = function formatTimeInterval(openTime, closeTime, anotherOpenTime, anotherCloseTime) {
  if (anotherOpenTime && anotherCloseTime) {
    return "".concat(openTime, " - ").concat(closeTime, " | ").concat(anotherOpenTime, " - ").concat(anotherCloseTime);
  }

  return "".concat(openTime, " - ").concat(closeTime);
};

var formatDayPeriods = function formatDayPeriods(periods) {
  try {
    return (typeof periods === 'string' ? JSON.parse(periods.replace(/'/g, '"')) : periods).reduce(function (acc, _ref) {
      var open = _ref.open,
          close = _ref.close;
      var day = DAYS[open.day];
      var openTime = open !== null && open !== void 0 && open.time ? formatTime(open.time) : '';
      var closeTime = close !== null && close !== void 0 && close.time ? formatTime(close.time) : '';
      var anotherOpenTime = open !== null && open !== void 0 && open.anotherTime ? formatTime(open.anotherTime) : '';
      var anotherCloseTime = close !== null && close !== void 0 && close.anotherTime ? formatTime(close.anotherTime) : '';
      var timeInterval = formatTimeInterval(openTime, closeTime, anotherOpenTime, anotherCloseTime);
      if (!acc[day]) acc[day] = [];
      acc[day].push(timeInterval);
      return acc;
    }, {});
  } catch (error) {
    console.error('Error in formatting google opening hours', error);
    return {};
  }
};

export var formatGoogleOpeningHours = function formatGoogleOpeningHours(periods) {
  if (!(periods !== null && periods !== void 0 && periods.length)) return [];

  try {
    var formattedHours = formatDayPeriods(periods);
    return SORTED_DAYS.map(function (day) {
      var _formattedHours$day;

      var intervals = ((_formattedHours$day = formattedHours[day]) === null || _formattedHours$day === void 0 ? void 0 : _formattedHours$day.join(' | ')) || 'Closed';
      return "".concat(day, ": ").concat(intervals);
    });
  } catch (error) {
    console.error('Error in formatting google opening hours', error);
    return [];
  }
};